import TeamAssignment from "./TeamAssignment";

export default TeamAssignment;